import React, {Component} from 'react';
import { Navbar } from 'react-bootstrap';
import logo from '../../media/logo.png';
import moment from 'moment';
import settings from '../../settings';

class BottomBar extends Component {
  state = {
    current: 'mail',
  };


  handleClick = e => {
    console.log('click ', e);
    this.setState({ current: e.key });
  };

  render() {
    const { current } = this.state;
    return (
        <Navbar fixed='bottom' bg="primary-dark" variant="dark" expand="lg" sticky="bottom" style={{zIndex: "0"}}>
            <Navbar.Text>© {settings.companyName} {settings.copyRightStartYear} - {moment().format('YYYY')}</Navbar.Text>
        </Navbar>
    );
  }
}

export default BottomBar;

